import React, { Component } from 'react';
import Alert from 'react-s-alert';

import Navegacao from './Navegacao';
import Questao from './Questao';
import CartaoResposta from './CartaoResposta';
import Loading from '../../Loading';
import { STATUS_QUESTAO } from '../../../const';

import * as SimuladoRequest from '../../../requests/simulado.request';

import VideoResolucaoEvents from '../../VideoResolucaoEvents';

let i_index = 0;

class VisualizarCorrecao extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingGeral: false,
            loadingQuestao: false,
            menuCartaoResposta: false,
            questaoAtual: 0,
            questoes: []
        }

        this.videoResolucaoEvents = VideoResolucaoEvents(props.idExam)

        this.onClickQuestao = this.onClickQuestao.bind(this);
        this.onClickProximaQuestao = this.onClickProximaQuestao.bind(this);
        this.onClickQuestaoAnterior = this.onClickQuestaoAnterior.bind(this);
        this.abrirMenuCartaoResposta = this.abrirMenuCartaoResposta.bind(this);
        this.fecharMenuCartaoResposta = this.fecharMenuCartaoResposta.bind(this);
        this.loadExam = this.loadExam.bind(this);
    }

    async loadExam(id) {
        try {
            if (!id) { throw new Error("O parâmetro idExam é obrigatório para visualizar a correção"); }

            //Exibindo o loading
            this.setState({ loadingGeral: true });

            //Obtendo o gabarito e as respostas do aluno
            var gabarito = await SimuladoRequest.getGabarito(id, this.props.idStudent);
            if (!gabarito) { throw new Error("Erro ao obter o gabarito."); }
            //console.log("gabarito", gabarito);

            this.atribuirGabaritoQuestoes(gabarito);

            //Obtendo a primeira questão
            var questao = await this.popularQuestao(0);
            if (!questao) { throw new Error("Erro ao popular a questão inicial."); }
            //console.log("questao", questao);

            this.setState({ loadingGeral: false });

        }
        catch (e) {
            console.error(e);
            Alert.error("Não foi possivel carregar este simulado. Tente novamente mais tarde.", { position: 'bottom-right' });
            //window.location.hash = "#/";
            this.setState({ loadingGeral: false });
        }
    }

    async componentDidMount() {
        await this.loadExam(this.props.idExam);
    }

    atribuirGabaritoQuestoes(marcacoes) {

        var questoes = [];
        var pontuacao = 0;

        for (let index = 0; index < marcacoes.length; index++) {
            const marcacao = marcacoes[index];

            var resposta = undefined;
            if (marcacao.a && marcacao.a[0]) {
                resposta = marcacao.a[0].idAnswer;
            }

            var respostaCorreta = undefined;
            var urlVideo = undefined;
            if (marcacao.a && marcacao.a[0] && marcacao.a[0].qa && marcacao.a[0].qa[0]) {
                respostaCorreta = marcacao.a[0].qa[0].idAnswerCorrect;
                urlVideo = marcacao.a[0].qa[0].qu && marcacao.a[0].qa[0].qu[0].txUrlVideo;

                if (urlVideo) {
                    //Formatando a url do video para o formato embbed
                    var videoId = urlVideo.toString().split("/")[3];
                    urlVideo = `https://player.vimeo.com/video/${videoId}`;
                }
            }

            var status = STATUS_QUESTAO.QUESTAO_STATUS_ERRADA;
            //Verifica se acertou a questão. Considera apenas as questões respondidas, deixa como errado as Em dúvida ou Em Branco
            if (marcacao.inStatus === STATUS_QUESTAO.QUESTAO_STATUS_RESPONDIDA && resposta === respostaCorreta) {
                status = STATUS_QUESTAO.QUESTAO_STATUS_CORRETA;
                pontuacao++;
            }

            questoes[index] = {
                incompleta: true,
                id: marcacao.idQuestion,
                enunciado: "",
                opcoes: [],
                resposta: resposta,
                respostaCorreta: respostaCorreta,
                urlVideo: urlVideo,
                status: status,
                nuDisplayOrder: marcacao.nuDisplayOrder
            };
        }

        this.setState({ questoes: questoes, pontuacao: pontuacao });
    }


    async popularQuestao(indexQuestao, naoCarregarProximaQuestao) {
        var result = false;

        //Vai para a questão  exibindo um loading
        if (!naoCarregarProximaQuestao) {
            this.setState({ questaoAtual: indexQuestao, loadingQuestao: true });
        }

        if (indexQuestao >= this.getTotalQuestoes())
            return false;

        //Verifica se já tem carregado a questão informada
        var questao = this.state.questoes[indexQuestao];
        // console.log('q', questao)
        //Se não tem a questão carregada ou se a questão está incompleta(Sem enunciado carregado)
        if (!questao || questao.incompleta) {

            //Armazena a resposta e o status anterior se houver
            var respostaAnterior = questao && questao.resposta;
            var respostaCorretaAnterior = questao && questao.respostaCorreta;
            var urlVideoAnterior = questao && questao.urlVideo;
            var statusAnterior = questao && questao.status;
            var numQuestao = questao ? questao.nuDisplayOrder : indexQuestao + 1;

            //Busca no servidor
            var questaoApi = await SimuladoRequest.getQuestao(this.props.idExam, numQuestao, this.props.idStudent);
            // console.log("questaoApi", questaoApi);
            if (!questaoApi) {
                console.error(`Não foi possivel carregar a questão ${indexQuestao + 1}. Index: ${indexQuestao}  nuDisplayOrder: ${(questao || {}).nuDisplayOrder} IdQuestion: ${(questao || {}).id}`);
                Alert.error(`Não foi possivel carregar a questão ${indexQuestao + 1}.`, { position: 'bottom-right' });
                this.setState({ loadingQuestao: false });
                return false;
            }

            //Armazena no array de questões carregadas
            questao = this.mapQuestaoApiToQuestao(questaoApi);
            var questoes = this.state.questoes;

            //Aplica a resposta e o status anterior
            if (respostaAnterior) {
                questao.resposta = respostaAnterior;
            }
            if (respostaCorretaAnterior) {
                questao.respostaCorreta = respostaCorretaAnterior;
            }
            if (urlVideoAnterior) {
                questao.urlVideo = urlVideoAnterior;
            }
            if (statusAnterior) {
                questao.status = statusAnterior;
            }

            questoes[indexQuestao] = questao;
            this.setState({ questoes: questoes, loadingQuestao: false });

            result = true;

        }
        else {
            this.setState({ loadingQuestao: false });

            result = true;
        }

        //Popula a questão na tela sem o loading
        if (!naoCarregarProximaQuestao) {

            //Deixa pré carregado a proxima questão para melhorar a experiencia de uso do aluno
            this.popularQuestao(indexQuestao + 1, true);
        }

        return result;
    }

    mapQuestaoApiToQuestao(questaoAPI) {

        var fonte = `(${questaoAPI.qs[0].coQuestionSource} ${questaoAPI.txYearReference}) `;

        var opcoes = questaoAPI.qs[0].qt[0].a.map(item => ({
            id: item.idAnswer,
            descricao: this.ajustarHtmlOpcao(item.txAnswer)
        }));

        var questao = {
            id: questaoAPI.idQuestion,
            enunciado: fonte + questaoAPI.txQuestion,
            opcoes: opcoes,
            resposta: undefined,
            status: STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO
        };

        return questao;
    }

    ajustarHtmlOpcao(htmlOpcao) {
        //Algumas opções de questões vem com o HTMl envolvidos com a tag <p>, e isso acaba quebrando o layout atual.
        //O codigo abaixo remove essa tag <p> que envolve a opção da questão
        var result = htmlOpcao;
        if (htmlOpcao && htmlOpcao.indexOf("<p") !== -1) {
            var idx = htmlOpcao.indexOf(">");
            var idxEndTag = htmlOpcao.indexOf("</p", idx);

            result = htmlOpcao.substring(idx + 1, idxEndTag);
        }
        return result;
    }


    getTotalQuestoes() {
        i_index = i_index + 1;
        return (this.state.questoes || []).length;
    }

    getQuestaoAtual() {
        if (this.state.questoes) {
            return this.state.questoes[this.state.questaoAtual] || {};
        }
        else {
            return {};
        }
    }

    getStatusQuestoes() {
        //var arrStatus = (this.state.questoes || []).map(questao => questao.status);
        var arrStatus = [];
        var qtd = this.getTotalQuestoes();
        for (let index = 0; index < qtd; index++) {

            var status = STATUS_QUESTAO.QUESTAO_STATUS_EM_BRANCO;

            const questao = this.state.questoes[index];
            if (questao) {
                status = questao.status;
            }

            arrStatus.push(status);
        }
        return arrStatus;
    }

    onClickQuestao(numeroQuestao) {
        var idx = (numeroQuestao - 1) || 0;
        //this.setState({ questaoAtual: idx, menuCartaoResposta: false });
        this.setState({ menuCartaoResposta: false });
        this.popularQuestao(idx);
        //window.scrollTo(0, 0);
    }

    onClickProximaQuestao() {
        if (this.state.questaoAtual + 1 < this.getTotalQuestoes()) {
            //this.setState({ questaoAtual: this.state.questaoAtual + 1 })
            this.popularQuestao(this.state.questaoAtual + 1);
            //window.scrollTo(0, 0);
            return true;
        }
        return false;
    }
    onClickQuestaoAnterior() {
        if (this.state.questaoAtual - 1 >= 0) {
            //this.setState({ questaoAtual: this.state.questaoAtual - 1 })
            this.popularQuestao(this.state.questaoAtual - 1);
            //window.scrollTo(0, 0);
        }
    }
    abrirMenuCartaoResposta() {
        this.setState({ menuCartaoResposta: true });
    }

    fecharMenuCartaoResposta() {
        this.setState({ menuCartaoResposta: false });
    }

    async componentWillReceiveProps(nextProps) {
        if (nextProps.idExam !== this.props.idExam) {
            // console.log('idExam receive', nextProps.idExam);
            await this.loadExam(nextProps.idExam);
        }
    }

    render() {
        // console.log('idExam', this.props.idExam);
        return (<div>

            {this.state.loadingGeral && <Loading text="Carregando o resultado do simulado..." />}

            {!this.state.loadingGeral && <div>
                <div>
                    <span className="edb-margin-small-right edb-large edb-text-bold">RESULTADO DO SIMULADO</span>
                    {/* <span className="edb-margin-small-right">|</span> */}
                    {/* <span className="edb-margin-small-right edb-small "> Realizado em 20/03/2019 16:30</span> */}
                    <span className="edb-margin-small-right">|</span>
                    <b className="edb-large2">{this.state.pontuacao}</b><span className="edb-small">/{this.getTotalQuestoes()} acertos</span>
                </div>

                <div className="edb-row edb-padding-small-medium edb-padding-small-mobile edb-margin-top">
                    <div className="edb-col m8">
                        <Navegacao
                            className="adap-light-gray"
                            questaoAtual={this.state.questaoAtual + 1}
                            totalQuestoes={this.getTotalQuestoes()}
                            esconderBtnDuvida={true}
                            esconderBtnBranco={true}
                            resposta={this.getQuestaoAtual().status === STATUS_QUESTAO.QUESTAO_STATUS_CORRETA}
                            onClickProxima={this.onClickProximaQuestao}
                            onClickAnterior={this.onClickQuestaoAnterior}
                        />

                        <Questao className="edb-margin-top edb-margin-bottom adap-light-gray"
                            somenteLeitura={true}
                            questao={this.getQuestaoAtual()}
                            numeroQuestao={this.state.questaoAtual + 1}
                            opcaoSelecionada={this.getQuestaoAtual().resposta}
                            loading={this.state.loadingQuestao}
                            videoResolucaoEvents={this.videoResolucaoEvents.forQuestion(this.getQuestaoAtual())}
                        />

                        <Navegacao
                            className="adap-light-gray"
                            questaoAtual={this.state.questaoAtual + 1}
                            totalQuestoes={this.getTotalQuestoes()}
                            esconderBtnDuvida={true}
                            esconderBtnBranco={true}
                            resposta={this.getQuestaoAtual().status === STATUS_QUESTAO.QUESTAO_STATUS_CORRETA}
                            onClickProxima={this.onClickProximaQuestao}
                            onClickAnterior={this.onClickQuestaoAnterior}
                        />

                        {this.state.iniciado && <div className="edb-col edb-right-align edb-hide-small edb-margin-top" >
                            <button className="edb-button edb-round adap-green" onClick={this.onClickFinalizar}>Finalizar simulado</button>
                        </div>}
                    </div>

                    <div className="edb-col m4 edb-padding-left ">
                        <div className="edb-hide-small edb-padding-large-right">
                            {/***************  Cartão Resposta (Dektop) ****************/}
                            <CartaoResposta
                                className="adap-light-gray"
                                questaoAtual={this.state.questaoAtual + 1}
                                statusQuestoes={this.getStatusQuestoes()}
                                onClickQuestao={this.onClickQuestao} />
                        </div>
                        <div className="edb-hide-large edb-hide-medium">

                            {/*************** Botão flutuante Cartão Resposta ****************/}
                            <div className="edb-round-large adap-green edb-tiny edb-line-height-tiny edb-padding-small adap-cartap-resposta-btn-label"
                                onClick={this.abrirMenuCartaoResposta}>CARTÃO DE <br />RESPOSTA</div>

                            <div className="adap-badge-large adap-green adap-cartap-resposta-btn" onClick={this.abrirMenuCartaoResposta}>
                                <i className="fas fa-clipboard-list"></i>
                            </div>

                            {/*************** Menu flutuante Cartão Resposta ****************/}
                            <div className="edb-sidebar  edb-collapse" style={{ width: "300px", right: "0", top: "64px", display: (this.state.menuCartaoResposta ? 'block' : 'none') }}>
                                <button className="edb-button edb-display-topright edb-large"
                                    onClick={this.fecharMenuCartaoResposta}>&times;</button>

                                <CartaoResposta
                                    questaoAtual={this.state.questaoAtual + 1}
                                    statusQuestoes={this.getStatusQuestoes()}
                                    onClickQuestao={this.onClickQuestao} />
                            </div>

                        </div>
                    </div>
                </div>
            </div>}
            <div id="image-zoom"></div>
        </div>);
    }
}

export default VisualizarCorrecao;